import React from 'react';

export const defaultLocale = 'en-US';

export const UIKitConfigContext = React.createContext({
  locale: defaultLocale,
  appName: '',
  appNameLower: '',
});
